import type { LayerGroupDefinition, MapStyleDefinition } from "../types";

export const layerGroups132: LayerGroupDefinition[] = [
  {
    id: "buildings",
    label: "ساختمان‌ها",
    styleLayerIds: ["building"],
    source: "iran",
    sourceLayer: "building",
    minzoom: 13,
    defaultVisible: true,
    readiness: "ready",
  },
  {
    id: "poi",
    label: "نقاط مهم",
    styleLayerIds: ["poi-circle", "poi-label"],
    source: "iran",
    sourceLayer: "poi",
    minzoom: 14,
    defaultVisible: true,
    readiness: "ready",
  },
  {
    id: "labels",
    label: "برچسب‌ها",
    styleLayerIds: [
      "place-label",
      "water-name-label",
      "aerodrome-label",
      "mountain-peak-label",
      "transportation-name-major",
      "transportation-name-local",
    ],
    source: "iran",
    sourceLayer: "transportation_name",
    minzoom: 0,
    defaultVisible: true,
    readiness: "ready",
  },
  {
    id: "housenumbers",
    label: "شماره ساختمان OSM",
    styleLayerIds: ["housenumber-label"],
    source: "iran",
    sourceLayer: "housenumber",
    minzoom: 14,
    defaultVisible: false,
    readiness: "experimental",
  },
];

export const standardStyle: MapStyleDefinition = {
  id: "standard",
  version: "1.3.2",
  styleUrl: "/map-next/basemap/1.3.2/style.json",
  schemaVersion: "mappino-omt-v1",
  rtlRequired: true,
  persianLabels: "not_available",
  layerGroups: layerGroups132,
  capabilities: {
    buildings: true,
    poi: true,
    labels: true,
    housenumbers: "experimental",
  },
};

export function resolveWorkerTemplate(template: string, origin: string): string {
  if (template.startsWith("/")) {
    return `${origin}${template}`;
  }
  if (template.startsWith(`${origin}/`)) {
    return template;
  }
  throw new Error("worker_url_must_be_same_origin");
}

export async function loadMapStyle(
  styleUrl: string,
  tileUrlTemplate: string,
  glyphUrlTemplate: string,
): Promise<unknown> {
  const response = await fetch(styleUrl, {
    headers: { Accept: "application/json" },
    cache: "force-cache",
  });
  if (!response.ok) {
    throw new Error(`style_unavailable:${response.status}`);
  }
  const style = (await response.json()) as {
    glyphs?: string;
    sources?: Record<string, { tiles?: string[] }>;
  };
  const iran = style.sources?.iran;
  if (iran) {
    iran.tiles = [resolveWorkerTemplate(tileUrlTemplate, window.location.origin)];
  }
  style.glyphs = resolveWorkerTemplate(glyphUrlTemplate, window.location.origin);
  return style;
}
